<div class="task-list-page">
  <div class="top-section">
    <div class="task-list-page-header-line">
      <div class="header-text">
        <h1>Completed history</h1>
      </div>

      <div class="button-div">
        <button mat-icon-button aria-label="Filter" (click)="toggleFilter()">
          <mat-icon>filter_alt</mat-icon>
        </button>
        <button mat-icon-button aria-label="Search" (click)="openSearch()">
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </div>

    <app-filter-task-buttons *ngIf="showFilter"></app-filter-task-buttons>
  </div>
  <div class="bottom-section horizontal-scroll">
    <div #listContainer class="list-container">
      <!-- Unassigned column -->
      <app-task-list
        *ngFor="let list of lists"
        [orgId]="orgId"
        [spaceId]="spaceId"
        [listId]="list.listId"
        [listFilter]="{
          listStage: 'completed',
          completedAtRange: { start: list.start, end: list.end },
          assignedTo: this.assignedTo,
          tagIds: this.tagIds
        }"
        [headerText]="list.headerText"
        class="list-padding task-list-min"
      ></app-task-list>
      <div #rightSpacer>&nbsp;</div>
    </div>
    <span></span>
  </div>
</div>
